import { BaseModel } from "./BaseModel";
import moment from "moment-timezone";

export class LCAgent extends BaseModel {
  schema = "/lcagent";
  constructor(params) {
    return super(params, "/lcagent");
  }

  set(params, validate) {
    if (params.alive) {
      params.alive = moment(params.alive).toISOString();
    }
    return super.set(params, validate);
  }
}
